<div>
  {{ "TAKEOVER_ACTION_BY" | translate: { user: user() } | capitalize }}
</div>
<div></div>
<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button class="g-col-2 g-start-11" kendoButton (click)="accept()" [themeColor]="'primary'">
      {{ "OK" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
